import React, { useEffect, useState } from "react";
import { Table, message, Button } from "antd";
import type { TableProps } from "antd";
import TenantBigScreenApi from "../../../../../../api/TenantBigScreenApi";

import {
    TenantBigScreensWrapper,
    ToolBarWrapper,
    ToolBarLeftWrapper,
    ToolBarRightWrapper,
    TableWrapper,
    TablesRow,
    TableColumn,
    TitleWrapper,
} from "./TenantBigScreens.styled";
import { SaveOutlined } from "@ant-design/icons";

interface Props {
    tenantView: any;
}

const TenantBigScreens: React.FC<Props> = (props) => {
    let [messageApi, contextHolder] = message.useMessage();
    let tenantBigScreenApi = new TenantBigScreenApi();

    let tenantSettingsJson = props.tenantView.tenant.settings;
    let tenantSettings = tenantSettingsJson ? JSON.parse(tenantSettingsJson) : {};

    let [overview, setOverview] = useState(tenantSettings.overviewType || "v1");
    let [deviceDetails, setDeviceDetails] = useState(tenantSettings.deviceDetailType || "v1");
    let [loading, setLoading] = useState<boolean>(false);

    let overviewOptions = [
        {
            "name": "详细版",
            "value": "v1",
            'thumbnail': 'overview-v1.png',
        },
        {
            "name": "简洁版",
            "value": "v2",
            'thumbnail': 'overview-v2.png',
        },
        {
            "name": "牵引车-v1",
            "value": "qyc",
            'thumbnail': 'qyc-overview.png',
        },
        {
            "name": "牵引车-v2",
            "value": "tractor",
            'thumbnail': 'tractor-overview.png',
        },
        {
            "name": "电动轮",
            "value": "electric-wheel",
            'thumbnail': 'electric-wheel-overview.png',
        },
    ];

    let deviceDetailsOptions = [
        {
            "name": "详细版",
            "value": "v1",
            'thumbnail': 'device-details-v1.png',
        },
        {
            "name": "简洁版",
            "value": "v2",
            'thumbnail': 'device-details-v2.png',
        },
        {
            "name": "牵引车-v1",
            "value": "qyc",
            'thumbnail': 'qyc-details.png',
        },
        {
            "name": "牵引车-v2",
            "value": "tractor",
            'thumbnail': 'tractor-details.png',
        },
        {
            "name": "电动轮",
            "value": "electric-wheel",
            'thumbnail': 'electric-wheel-details.png',
        },
    ];

    useEffect(() => {
        let load = async () => {
            setLoading(true);
            try {
                let tenantSettings = (await tenantBigScreenApi.getTenantBigScreens(props.tenantView.tenant.id)).data.data;
                let bigScreenSettings = tenantSettings.bigScreenSettings;
                setOverview(bigScreenSettings?.overviewType || "v1");
                setDeviceDetails(bigScreenSettings?.deviceDetailsType || "v1");
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [props.tenantView]);

    let onSave = async () => {
        let tenantId = props.tenantView.tenant.id;
        setLoading(true);
        try {
            await tenantBigScreenApi.updateTenantBigScreenSettings(
                tenantId,
                overview,
                deviceDetails,
            );
            messageApi.open({ type: 'success', content: '保存成功' });
        } catch (e) {
            messageApi.open({ type: 'error', content: '保存失败' });
        } finally {
            setLoading(false);
        }
    };

    let columns = [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            width: '200px',
            align: 'left',
            render: (text: string, record: any) => <b>{record.name}</b>
        },
        {
            title: '预览图',
            dataIndex: 'image',
            key: 'image',
            align: 'left',
            render: (text: any, record: any) => {
                let url = 'static/images/bigscreen-thumbnail/' + record.thumbnail;
                return <img src={url} alt={record.name} style={{ width: 160, height: 90, objectFit: 'cover', borderRadius: 4 }} />
            }
        }
    ];

    let overviewRowSelection: TableProps<any>['rowSelection'] = {
        type: 'radio',
        selectedRowKeys: [overview],
        onSelect: (record) => {
            setOverview(record.value);
        },
    };

    let deviceRowSelection: TableProps<any>['rowSelection'] = {
        type: 'radio',
        selectedRowKeys: [deviceDetails],
        onSelect: (record) => {
            setDeviceDetails(record.value);
        },
    };

    return (
        <TenantBigScreensWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                    <Button type="primary" icon={<SaveOutlined />} onClick={onSave} loading={loading}>保存</Button>
                </ToolBarLeftWrapper>
                <ToolBarRightWrapper>
                </ToolBarRightWrapper>
            </ToolBarWrapper>
            <TableWrapper>
                <TablesRow>
                    <TableColumn>
                        <TitleWrapper>系统总览</TitleWrapper>
                        <Table
                            rowKey={(record) => record.value}
                            columns={columns}
                            rowSelection={overviewRowSelection}
                            dataSource={overviewOptions}
                            loading={loading}
                            pagination={false}
                        />
                    </TableColumn>

                    <TableColumn>
                        <TitleWrapper>数据详情</TitleWrapper>
                        <Table
                            rowKey={(record) => record.value}
                            columns={columns}
                            rowSelection={deviceRowSelection}
                            dataSource={deviceDetailsOptions}
                            loading={loading}
                            pagination={false}
                        />
                    </TableColumn>
                </TablesRow>
            </TableWrapper>
        </TenantBigScreensWrapper>
    );
};

export default TenantBigScreens;
